import { applyInterceptor } from '../utils/axios';
import { Api, HttpClient } from './apiClient';

export * from './apiClient';

const httpClient = new HttpClient({
  baseURL: WISORY_SDK_SETTINGS.API_URL
});

const axioInstance = httpClient.instance;

// apply this for refresh token and accesstoken
applyInterceptor(axioInstance);

export const baseAPI = new Api(httpClient);

export default baseAPI;
